import { connect, mapReadPretty, mapProps } from "@formily/react";
import {
  CurrencyDisplay,
  CurrencyInput as CurrencyInputBase,
  OffsetDisplay,
  OffsetInput as OffsetInputBase,
  NumberInput as NumberInputBase,
} from "../base/NumberInput";
import { isField } from "@formily/core";

export const NumberInput = connect(
  NumberInputBase,
  mapProps((props, field) => {
    if (!isField(field)) return props;

    return {
      ...props,
      label: field.title,
      value: field.value,
      description: field.description,
      errorMessage: field.selfErrors[0],
      isDisabled: props.isDisabled ?? field.disabled,
      onChange: (value) => {
        void field.onInput(value);
      },
    };
  }),
  mapReadPretty((props) => {
    const isNumeric = !isNaN(props.value);
    return (
      <span>
        <span>{isNumeric && props.value}</span>
        <span>{isNumeric && props.endIcon}</span>
      </span>
    );
  }),
);

export const CurrencyInput = connect(
  CurrencyInputBase,
  mapProps((props, field) => {
    if (!isField(field)) return props;

    return {
      ...props,
      label: field.title,
      value: field.value,
      description: field.description,
      errorMessage: field.selfErrors[0],
      isDisabled: field.disabled,
      onChange: (value) => {
        void field.onInput(value);
      },
    };
  }),
  mapReadPretty((props) => {
    return <CurrencyDisplay value={isNaN(props.value) ? "" : props.value} />;
  }),
);

export const OffsetInput = connect(
  OffsetInputBase,
  mapProps((props, field) => {
    if (!isField(field)) return props;

    return {
      ...props,
      label: field.title,
      value: field.value,
      description: field.description,
      errorMessage: field.selfErrors[0],
      isDisabled: field.disabled,
      onChange: (value) => {
        void field.onInput(value);
      },
    };
  }),
  mapReadPretty((props) => {
    return <OffsetDisplay value={props.value} />;
  }),
);
